import React from "react";

// Dialog built on the same styles as the editor's "Add product" popup
export default function Modal({ eyebrow, title, description, onClose, children, wide }) {
  return (
    <div className="product-modal-backdrop" role="presentation" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="product-modal" style={wide ? undefined : { width: "min(520px,100%)" }} role="dialog" aria-modal="true" aria-label={title}>
        <div className="product-modal-head">
          <div>
            {eyebrow && <span className="eyebrow">{eyebrow}</span>}
            <h2>{title}</h2>
            {description && <p>{description}</p>}
          </div>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
